import DiagnosisI from '@interfaces/patients/diagnosisI';
import emrServiceApiInstance from '@services/clients/emr';
import axiosApiInstance from '@services/custom-axios-instance';
import { generateUrl } from "@services/generateUrl/generateUrl";

export function getPatientDiagnosis(
    patientUsername: string
): Promise<DiagnosisI[]> {
    return axiosApiInstance
        .get(
            `${generateUrl()}/emr/diagnosis/patient-username/${patientUsername}`
        )
        .then((response) => {
            const data = response.data as unknown;
            return data as DiagnosisI[];
        });
}

export function getPatientDiagnostic(diagnosisId: string): Promise<DiagnosisI> {
    return axiosApiInstance
        .get(
            `${generateUrl()}/emr/diagnosis/patient/${diagnosisId}`
        )
        .then((response) => {
            const data = response.data as unknown;
            return data as DiagnosisI;
        });
}

export function postPatientDiagnosis(
    diagnosis: DiagnosisI
): Promise<DiagnosisI> {
    return axiosApiInstance
        .post(
            `${generateUrl()}/emr/diagnosis/patient/`,
            diagnosis
        )
        .then((response) => {
            const data = response.data as unknown;
            return data as DiagnosisI;
        });
}

export function updatePatientDiagnosis(data: {
    appointmentId: string | null;
    category: {
        code: string;
        name: string;
    };
    clinicalStatus: {
        code: string;
        name: string;
    };
    date: string;
    descripcion: string;
    hidden: boolean | null;
    id: string;
    verificationStatus: {
        code: string;
        name: string;
    }
    diagnosticCie10Code: string,
    firstTimeDiagnosis: boolean,
    withPulmonaryTuberculosis: string
}): Promise<DiagnosisI> {
    return axiosApiInstance
        .put(
            `${generateUrl()}/emr/diagnosis/patient/`,
            data
        )
        .then((response) => {
            const data = response.data as unknown;
            return data as DiagnosisI;
        });
}

export function deletePatientDiagnosis(diagnosisId: string) {
    return axiosApiInstance
        .delete(
            `${generateUrl()}/emr/diagnosis/patient/${diagnosisId}`
        )
        .then((response) => {
            const data = response.data as unknown;
            return data;
        });
}

export function getFirsTimeCodeCIE10(
    patientUsername: string,
    cie10Code: string,
): Promise<DiagnosisI> {
    return axiosApiInstance
        .get(
            `${generateUrl()}/emr/diagnosis/first-time/${patientUsername}/${cie10Code}`
        )
        .then((response) => {
            const data = response.data as unknown;
            return data as DiagnosisI;
        });
}
export function getDiagnosisHistoryByCIE10Code(
    patientUsername: string,
    cie10Code: string,
): Promise<DiagnosisI[]> {
    return axiosApiInstance
        .get(
            `${generateUrl()}/emr/diagnosis/${patientUsername}/${cie10Code}`
            )
        .then((response) => {
            const data = response.data as unknown;
            return data as DiagnosisI[];
        });
}

export function getDiagnosisHistoryByIRAorEDA(
    patientUsername: string,
    section: 'ira' | 'eda',
    firstTime?: boolean,
): Promise<DiagnosisI[]> {
    let url = `${generateUrl()}/emr/diagnosis/check/${section}/history/${patientUsername}`
    if(firstTime !== undefined) url = url + `?firstTime=${firstTime}`
    return axiosApiInstance
        .get(url)
        .then((response) => {
            const data = response.data as unknown;
            return data as DiagnosisI[];
        });
}
export async function haveDiagnosisWithIRAorEDA(patientUsername: string, section: 'ira' | 'eda', firstTime?: boolean,) 
{
    let url = `/diagnosis/check/${section}/history/${patientUsername}`;
    const params = new URLSearchParams();
    if(firstTime )
        params.append("firstTime", String(firstTime));
    const strParams = params.toString();
    if(strParams)
        url += `?${strParams}`;
    const response = await emrServiceApiInstance.get<boolean>(url)
    return response.data
}
export async function haveDiagnosisWithPneumonia(patientUsername: string, section: 'ira' | 'eda', firstTime?: boolean,) 
{
    let url = `/diagnosis/check/${section}/history/${patientUsername}`;
    const params = new URLSearchParams();
    if(firstTime )
        params.append("firstTime", String(firstTime));
    const strParams = params.toString();
    if(strParams)
        url += `?${strParams}`;
    const response = await emrServiceApiInstance.get<boolean>(url)
    return response.data
}
